import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { UiSettingsApiService } from '../services/ui-settings-api.service';
import { map, tap } from 'rxjs/operators';
import { UiSettingsStore } from '../+state/ui-settings.store';
import { UiSettingsQuery } from '../+state/ui-settings.query';
let UiSettingsService = class UiSettingsService {
    constructor(_uiSettingsApiService, _uiSettingsStore, _uiSettingsQuery) {
        this._uiSettingsApiService = _uiSettingsApiService;
        this._uiSettingsStore = _uiSettingsStore;
        this._uiSettingsQuery = _uiSettingsQuery;
    }
    getUiSettings() {
        return this._uiSettingsApiService.getUiSettings().pipe(tap((res) => this._uiSettingsStore.updateUiSettings(res)), map((r) => r));
    }
    updateConfigSettings(configSettings) {
        return this._uiSettingsApiService.updateConfigSettings(configSettings).pipe(tap((res) => this._uiSettingsStore.updateConfigSettings(configSettings)));
    }
};
UiSettingsService.ctorParameters = () => [
    { type: UiSettingsApiService },
    { type: UiSettingsStore },
    { type: UiSettingsQuery }
];
UiSettingsService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [UiSettingsApiService,
        UiSettingsStore,
        UiSettingsQuery])
], UiSettingsService);
export { UiSettingsService };
